import React from "react";
import { StarChartsListContainerProps } from "../../types/types";
import StarChartsOrgListPresentation from "../../presentation/starChartOrg.list.presentation/StarChartOrgListPresentation";


const StarChartsOrgListContainer: React.FC<StarChartsListContainerProps> = ({
  starChartsList,
  page,
  limit,
  setPage,
  setLimit,
  sort,
  onSort,
  onStarChartDelete,

}) => {

  return (
    <StarChartsOrgListPresentation
    starChartsList={starChartsList}
      page={page}
      limit={limit}
      setPage={setPage}
      setLimit={setLimit}
      sort={sort}
      onSort={onSort}
      onStarChartDelete={onStarChartDelete}
    />
  )
}

export default StarChartsOrgListContainer
